
<div class="p-grid" style="margin:15px" >

    <div class="p-col-12" ngStickyNav>
        <!-- DETAILS MODERATION -->
        <p-panel [toggleable]="false" [showHeader]="true" class="p-col-12" styleClass="details">
            <p-header>DETAILS DE LA MODERATION</p-header>
            <div class="p-grid">
                <div class="p-col-4" style="text-align: center;">
                    Num point d'accueil : {{detailsPtl["num_point_accueil"]}}
                </div>
                <div class="p-col-4" style="text-align: center;">
                    Identifiant Bon Plan : {{detailsPtl["id_bon_plan"]}}
                </div>
                <div class="p-col-4" style="text-align: center;">
                    ETAT : {{ detailsPtl["etat"] }}
                </div>
                <div class="p-col-6" style="text-align: center;">
                    COMPLEXITE : {{ detailsPtl['libelle_complexite'] }}
                </div>
                <div class="p-col-6" style="text-align: center;">
                    TYPE : {{ detailsPtl["type_ptl"] }}
                </div>
            </div>
        </p-panel>
        <!-- FIN DETAILS MODERATION -->

        <!-- DEBUT TOOLBAR PAUSE -->
        <p-toolbar class=" toolbar">
            <div class="ui-toolbar-group-left">
                <!-- <p-button  type="button" [disabled]="pause" icon="pi pi-pause" label="Pause" class="btn-pause" (click)="beginPause()"></p-button> -->
                <span style="visibility: hidden;">
                    <strong>TEMPS PASSE : </strong> <b [chronometer]="chrono" [chronoEvents]="true" (onChronoEvent)="onChronoEvent($event)"></b>
                </span>
                <span style="font-size: x-large; color: #423a39ba;">
                    ENSEIGNE : {{ detailsPtl["enseigne_guide"] }}
                </span>
                <span>
                    <button pButton type="button" [disabled]="disabled" class="enseigne-guide-btn" icon="pi pi-external-link" iconPos="right" (click)="verifierEnseigne()"></button>
                </span>
            </div>

            <div class="ui-toolbar-group-right" style="font-size: x-large; color: #423a39ba; margin : 7px;">
                <strong>DMT : </strong>
                <span *ngIf="boolIsNegatif" style="color: tomato"> <b>- </b> <b [chronometer]="chronoNegatif"  [chronoEvents]="true" (onChronoEvent)="onChronoEventNegatif($event)"></b>
                 </span>
                  <countdown *ngIf="!boolIsNegatif" #cd [config]="config" ></countdown>
            </div>

        </p-toolbar>
        <!-- FIN TOOLBAR PAUSE -->
    </div>

    <!-- CONTENU TITRE BON PLAN -->
    <ng-template [ngIf]="titreBonPlan['id_contenu']">
        <p-panel  [transitionOptions]="'160ms'" [toggleable]="true" class="p-col-12"  [toggler]="'header'" [collapsed]="collapseTitreBonPlan">
            <p-header > Titre du bon plan </p-header>
            <div class="p-grid">
                <app-description [type-contenu]="'titreBonPlan'" [is-retour]="getIfRetour()" [id-moderation]="idModeration" [numero-contenu]="titreBonPlan['numero_contenu']" [content]="titreBonPlan['valeur_contenu']" [doute]=" titreBonPlan['doute'] "   [erreurs]=" titreBonPlan['erreurs'] " [valide]="titreBonPlan['is_valid']"  [valide-cq]="titreBonPlan['is_valid_cq']"  [erreurs-cq]=" titreBonPlan['erreurs_cq'] " (erreursChangedEvent)="erreursTitreBPChanged($event)" (validChangedEvent)="setValidationTitreBP($event)" (descriptionChangedEvent)="titreBPChanged($event)" (douteEvent)="contenuDouteUpdated($event)" class="p-col-12"></app-description>
            </div>
        </p-panel>
    </ng-template>
    <!-- FIN CONTENU TITRE BON PLAN -->

    <!-- CONTENU PHRASE d'ACCROCHE -->
    <ng-template [ngIf]="phraseAccroche['id_contenu']">
        <p-panel  [transitionOptions]="'160ms'" [toggleable]="true" class="p-col-12"  [toggler]="'header'" [collapsed]="collapsePhraseAccroche">
            <p-header > Phrase d'accroche </p-header>
            <div class="p-grid">
                <app-description [type-contenu]="'phraseAccroche'" [is-retour]="getIfRetour()" [id-moderation]="idModeration" [numero-contenu]="phraseAccroche['numero_contenu']" [content]="phraseAccroche['valeur_contenu']" [doute]=" phraseAccroche['doute'] "   [erreurs]=" phraseAccroche['erreurs'] " [valide]="phraseAccroche['is_valid']"  [valide-cq]="phraseAccroche['is_valid_cq']"  [erreurs-cq]=" phraseAccroche['erreurs_cq'] " (erreursChangedEvent)="erreursPhraseAccrocheChanged($event)" (validChangedEvent)="setValidationPhraseAccroche($event)" (descriptionChangedEvent)="phraseAccrocheChanged($event)" (douteEvent)="contenuDouteUpdated($event)" class="p-col-12"></app-description>
            </div>
        </p-panel>
    </ng-template>
    <!-- FIN CONTENU PHRASE d'ACCROCHE -->


    <!-- CONTENU DETAIL -->
    <ng-template [ngIf]="detail['id_contenu']">
        <p-panel  [transitionOptions]="'160ms'" [toggleable]="true" class="p-col-12"  [toggler]="'header'" [collapsed]="collapseDetails">
            <p-header > Détails du bon plan </p-header>
            <div class="p-grid">
                <app-description [type-contenu]="'detail'" [is-retour]="getIfRetour()" [id-moderation]="idModeration" [numero-contenu]="detail['numero_contenu']" [content]="detail['valeur_contenu']" [doute]=" detail['doute'] "   [erreurs]=" detail['erreurs'] " [valide]="detail['is_valid']"  [valide-cq]="detail['is_valid_cq']"  [erreurs-cq]=" detail['erreurs_cq'] " (erreursChangedEvent)="erreursDetailChanged($event)" (validChangedEvent)="setValidationDetail($event)" (descriptionChangedEvent)="detailChanged($event)" (douteEvent)="contenuDouteUpdated($event)" class="p-col-12"></app-description>
            </div>
        </p-panel>
    </ng-template>
    <!-- FIN CONTENU DETAIL -->


    <!-- CONTENU SITE WEB -->
    <p-panel *ngIf="siteWeb['id_contenu']"  [transitionOptions]="'160ms'" [toggleable]="true"  class="p-col-12" [toggler]="'header'" [collapsed]="collapseSite">
        <p-header > Site web </p-header>
        <app-reseaux-sociaux [is-retour]="getIfRetour()"  [id-moderation]="idModeration" [numero-contenu]="siteWeb['numero_contenu']"  [lien]="siteWeb['valeur_contenu']" [valide]="siteWeb['is_valid']" [erreurs]=" siteWeb['erreurs'] " [valide-cq]=" siteWeb['is_valid_cq']" [is-site]="true" [erreurs-cq]=" siteWeb['erreurs_cq'] " [doute]="siteWeb['doute']" (validChangedEvent)="setURLValidity(true, $event)" (linkChangedEvent)="setURLLink(true, $event)" (erreursChangedEvent)="setURLErrors(true, $event)" (douteEvent)="contenuDouteUpdated($event)"></app-reseaux-sociaux>
    </p-panel>
    <!-- FIN CONTENU SITE WEB -->

    <!-- CONTENU LOGO -->
    <p-panel  [transitionOptions]="'160ms'" *ngIf="logo['id_contenu']" [toggleable]="true"  class="p-col-12" [toggler]="'header'" [collapsed]="collapseLogo">
        <p-header > Logo </p-header>
        <app-photos [is-retour]="getIfRetour()" [no-duplicate]="true" [site-web]="siteWeb['valeur_contenu']" [id-moderation]="idModeration" [numero-contenu]="logo['numero_contenu']" [lien]="logo['valeur_contenu']" [(erreurs)]="logo['erreurs'] " [valide]=" logo['is_valid'] " [valide-cq]=" logo['is_valid_cq'] " [is-logo]="true" [erreurs-cq]=" logo['erreurs_cq'] " [doute]="logo['doute']" (validChangedEvent)="setMediaValidity(true, $event)" (erreursChangedEvent)="setMediaErrors(true, $event)" (douteEvent)="contenuDouteUpdated($event)"></app-photos>
    </p-panel>
    <!-- FIN CONTENU LOGO -->

    <!-- CONTENU RESEAUX SOCIAUX -->
    <div class="p-col-12"  *ngIf="reseauxSociaux.length > 0">
        <p-panel [transitionOptions]="'160ms'" *ngFor="let rs of reseauxSociaux" [toggleable]="true"  class="p-col-12" [toggler]="'header'" [collapsed]="collapseRs[rs['id_contenu']]">
            <p-header > Réseaux sociaux </p-header>
            <app-reseaux-sociaux  [is-retour]="getIfRetour()" [id-moderation]="idModeration"  [numero-contenu]="rs['numero_contenu']" [erreurs]=" rs['erreurs'] "  [lien]="rs['valeur_contenu']" [valide]="rs['is_valid']" [id-contenu]="rs['id_contenu']" [valide-cq]=" rs['is_valid_cq'] " [erreurs-cq]=" rs['erreurs_cq'] " [doute]="rs['doute']" (validChangedEvent)="setURLValidity(false, $event)" (linkChangedEvent)="setURLLink(false, $event)" (erreursChangedEvent)="setURLErrors(false, $event)" (douteEvent)="contenuDouteUpdated($event)"></app-reseaux-sociaux>
        </p-panel>
    </div>
    <!-- FIN CONTENU RESEAUX SOCIAUX -->


    <!-- CONTENU DESCRIPTION -->
    <ng-template [ngIf]="description['id_contenu']">
        <p-panel  [transitionOptions]="'160ms'" [toggleable]="true" class="p-col-12"  [toggler]="'header'" [collapsed]="collapseDescription">
            <p-header > Description </p-header>
            <div class="p-grid">
                <app-description [is-retour]="getIfRetour()" [id-moderation]="idModeration" [numero-contenu]="description['numero_contenu']" [content]="description['valeur_contenu']" [doute]=" description['doute'] "   [erreurs]=" description['erreurs'] " [valide]="description['is_valid']"  [valide-cq]="description['is_valid_cq']"  [erreurs-cq]=" description['erreurs_cq'] " (erreursChangedEvent)="erreursDescriptionChanged($event)" (validChangedEvent)="setValidationDescription($event)" (descriptionChangedEvent)="descriptionChanged($event)" (douteEvent)="contenuDouteUpdated($event)" class="p-col-12"></app-description>
            </div>
        </p-panel>
    </ng-template>
    <!-- FIN CONTENU DESCRIPTION -->

    <!-- CONTENU PHOTO -->
    <div class="p-col-12" *ngIf="photos.length > 0">
        <p-panel  [transitionOptions]="'160ms'" *ngFor="let photo of photos" [toggleable]="true"  class="p-col-12" [toggler]="'header'" [collapsed]="collapsePhoto[photo['id_contenu']]">
            <p-header > Photos </p-header>
            <app-photos  [is-retour]="getIfRetour()" [id-moderation]="idModeration" [site-web]=" siteWeb['valeur_contenu'] " [numero-contenu]="photo['numero_contenu']" [doute]="photo['doute']"  [lien]="photo['valeur_contenu']" [(erreurs)]=" photo['erreurs'] " [valide-cq]=" photo['is_valid_cq'] "  [valide]=" photo['is_valid'] " [id-contenu]=" photo['id_contenu'] " [erreurs-cq]="photo['erreurs_cq']" (validChangedEvent)="setMediaValidity(false, $event)" (erreursChangedEvent)="setMediaErrors(false, $event)" (douteEvent)="contenuDouteUpdated($event)"></app-photos>
        </p-panel>
    </div>
    
    <!-- FIN CONTENU PHOTO -->

<!--
    <p-panel  [transitionOptions]="'160ms'" [toggleable]="true"  class="p-col-12" [toggler]="'header'">
        <p-header > Offre bon plan </p-header>
        <app-offre lien="https://images.unsplash.com/photo-1589831313792-01cad3ff41cb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80" contenu="Appareil très bonne état année XXXX marque CANON à vendre ou à louer"></app-offre>
    </p-panel>
-->
    <div class="p-col-2">
        <button pButton type="button" [disabled]="disabled" label="Enregistrer la modération" style="width: 100%;" icon="pi pi-save" iconPos="right" (click)="nextTraitement(7)"></button>
    </div>
    <div class="p-col-2">
        <button pButton type="button" [disabled]="disabled" label="Valider et quitter" style="width: 100%;" icon="pi pi-sign-out" iconPos="right" (click)="nextTraitement(2,true)"></button>
    </div>
    <div class="p-col-6">

    </div>
    <div class="p-col-2">
        <button pButton type="button" [disabled]="disabled" label="Valider la modération" style="width: 100%;" icon="pi pi-check" iconPos="right" (click)="nextTraitement(2)"></button>
    </div>
   <!--  <div class="p-col-2">
        <button pButton type="button" [disabled]="disabled" label="Annuler" class="ui-button-secondary" style="width: 100%;" (click)="annulerTraitement()"></button>
    </div> -->
</div>

<p-sidebar  [(visible)]="pause" [modal]="true" [showCloseIcon]="false" [fullScreen]="true" class="pause-modal p-form" [appendTo]="'body'" [blockScroll]="true" styleClass="pause-sidebar">
    <div class="p-grid" style="padding-top: 350px; ">
        <div class="p-col-12" style="text-align: center;">
            <strong>TEMPS PASSE : </strong> <b [chronometer]="chronoPause" (onChronoEvent)="onChronoPauseEvent($event)"></b>
        </div>
        <div class="p-col-5"></div>
        <p-dropdown class="p-col-2" [style]=" {'width': '100%'} " [disabled]="disableSelectionPause" [options]="pauseItem" [(ngModel)]="selectedPause" placeholder="Selectionnez une pause" [appendTo]="'body'" (onChange)="pauseChoisi()"></p-dropdown>
        <div class="p-col-5"></div>
        <div class="p-col-5"></div>
        <ng-template [ngIf]="!endPauseClickable()">
            <p-button class="p-col-2" type="button" [disabled]="endPauseClickable()" icon="pi pi-play" [style]=" {'width': '100%'} " label="Reprendre traitement" styleClass="btn-traiter" (onClick)="endPause()"></p-button>
        </ng-template>
    </div>
</p-sidebar>

<p-toast [styleClass]="'message'">
    <ng-template let-message pTemplate="message">
        <div style="text-align: center">
            <i class="pi pi-exclamation-triangle" style="font-size: 3em; font-weight: bold; "></i>
            <h3>{{message.summary}}</h3>
            <p>{{message.detail}}</p>
        </div>
    </ng-template>
</p-toast>
